import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fe9ee48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "modal__inner__body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "input__file" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address line", -1))
const _hoisted_6 = { class: "input__file" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City / Town", -1))
const _hoisted_8 = { class: "input__file" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1))
const _hoisted_10 = {
  key: 0,
  class: "address__postcodes"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_13 = {
  key: 4,
  class: "onboarding-not-service"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_commonDialog = _resolveComponent("commonDialog")!

  return (_openBlock(), _createBlock(_component_commonDialog, {
    HeaderTittle: "Residential Address",
    title: "What’s your residential address",
    description: "This is required for our compliance requirements.",
    onClickBackButton: $setup.onClickBackButton,
    class: "carousel__dialog custom__modal__box",
    height: "100%"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_form, {
            ref: "postcodeform",
            rules: $setup.rules,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(() => [
              ($setup.isShowAddressData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        variant: "outlined",
                        class: "c-input rounded-full",
                        modelValue: $setup.address,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.address) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_v_text_field, {
                        density: "compact",
                        variant: "outlined",
                        class: "c-input rounded-full",
                        modelValue: $setup.place,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.place) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_v_text_field, {
                  density: "compact",
                  placeholder: "e.g E1 1BA",
                  variant: "outlined",
                  class: "c-input rounded-full",
                  modelValue: $setup.postCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.postCode) = $event)),
                  rules: $setup.rules.postCode,
                  disabled: $setup.isShowAddressData ? true : false
                }, null, 8, ["modelValue", "rules", "disabled"]),
                ($setup.addressListfromPostcode?.length && !$setup.isShowAddressData)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.addressListfromPostcode, ({ DPA }) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: DPA?.UPRN,
                          onClick: ($event: any) => ($setup.handleSelectAddress(DPA))
                        }, [
                          _createElementVNode("div", null, _toDisplayString(DPA?.ADDRESS), 1)
                        ], 8, _hoisted_11))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              ($setup.errorMessagePostcode)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.errorMessagePostcode), 1))
                : _createCommentVNode("", true),
              (!$setup.isShowAddressData)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 2,
                    class: _normalizeClass(["button disabled", { 'button-orange': $setup.isDisabledNextButton }]),
                    size: "large",
                    block: "",
                    loading: $setup.isActiveNextButton,
                    disabled: !$setup.isDisabledNextButton,
                    onClick: $setup.GoToFindAddress
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" find address ")
                    ]),
                    _: 1
                  }, 8, ["class", "loading", "disabled", "onClick"]))
                : _createCommentVNode("", true),
              ($setup.isShowAddressData)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 3,
                    class: _normalizeClass(["button disabled", { 'button-orange': $setup.isDisabledNextButton }]),
                    size: "large",
                    block: "",
                    disabled: !$setup.isDisabledNextButton,
                    loading: $setup.loadingContinue,
                    onClick: $setup.onClickContinue
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" CONTINUE ")
                    ]),
                    _: 1
                  }, 8, ["class", "disabled", "loading", "onClick"]))
                : _createCommentVNode("", true),
              ($setup.isShowAddressData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _createTextVNode(" Address Not Correct? "),
                      _createElementVNode("span", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changeAddress && $setup.changeAddress(...args)))
                      }, [
                        _createTextVNode("Change Address "),
                        _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["rules"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClickBackButton"]))
}